import React from 'react'
import ColumnFlexBox from './ColumnFlexBox'
import RowFlexBox from './RowFlexBox'
import FlexBox from './FlexBox'

import { InfraComponents } from '../../../InfraFacade'

const NumberFormat = require('webapps-frontend-components/src/main/shared/utils/NumberFormat').NumberFormat

const PlatformLogo = InfraComponents.PlatformLogo

const PlatformContainer = (props) => (
  <RowFlexBox className='platform reverse no-wrap'>
    <span className='platform-reach-count'>{NumberFormat.formatWithUnit(props.reach, 2)}</span>
    <span className='platform-reach'>reach</span>
    <PlatformLogo platformId={props.id} color />
  </RowFlexBox>
)

const CapacityAndPlatform = ({platform, count}) => {
  return (
    <ColumnFlexBox className='capacity-platform-container' width={'30%'}>
      <ColumnFlexBox className='capacity-container'>
        <FlexBox className='capacity-count'>{NumberFormat.formatWithUnit(count, 2)}</FlexBox>
        <FlexBox className='capacity-info'>total estimated reach</FlexBox>
      </ColumnFlexBox>
      <ColumnFlexBox className='platform-container'>
        <PlatformContainer reach={platform.reach} id={platform.id} key={'pf' + platform.id} />
      </ColumnFlexBox>
    </ColumnFlexBox>
  )
}

export default CapacityAndPlatform



// WEBPACK FOOTER //
// ../src/commons/components/SegmentsPopupContent/CapacityAndPlatform.js